import { takeLatest, call, put } from 'redux-saga/effects'
import { createMultimediaInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateMultimediaBlock(data: any) {
  return await createMultimediaInstance(data)
}

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* newMultimediaBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateMultimediaBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createMultimediaWatcherSaga() {
  yield takeLatest(
    fromActions.MULTIMEDIA_BLOCK_CREATE,
    newMultimediaBlockEffectSaga
  )
}
